/**
 * CardIcon Component
 *
 * Icon wrapper sub-component for compound Card API
 * Provides proper spacing and alignment for icons in card headers
 */

import React from 'react';
import { cx } from '@/styled-system/css';
import { cardIcon } from './card.styles';
import type { CardIconProps } from './types';

export const CardIcon = React.forwardRef<HTMLSpanElement, CardIconProps>(
  ({ children, className, ...restProps }, ref) => {
    return (
      <span ref={ref} className={cx(cardIcon, className)} aria-hidden="true" {...restProps}>
        {children}
      </span>
    );
  },
);

CardIcon.displayName = 'CardIcon';

export type { CardIconProps };
